import { type ReactElement, type ReactNode, useEffect, useMemo } from 'react';
import { getStoredContext, updateSessionContext } from '@/auth/sessionStorage';
import { setOrgIdProvider } from '@/shared/data/client';
import { useContextSelection } from '@/shared/hooks/useContextSelection';
import { OrganisationFilterContext } from './organisationContext';

export const OrganisationFilterProvider = ({ children }: { children: ReactNode }): ReactElement => {
  const { value: selectedOrganisationId, setValue: setSelectedOrganisationId } =
    useContextSelection({
      getInitialValue: () => {
        if (typeof window === 'undefined') return null;
        const { lastOrganisationId } = getStoredContext();
        return lastOrganisationId;
      },
      normalize: (value) => (value && value.length > 0 ? value : null),
      onPersist: (value) => {
        updateSessionContext(value, undefined);
      },
    });

  useEffect(() => {
    const provider = (): string | null => selectedOrganisationId;
    setOrgIdProvider(provider);
    return () => {
      setOrgIdProvider(undefined);
    };
  }, [selectedOrganisationId]);

  const value = useMemo(() => {
    return { selectedOrganisationId, setSelectedOrganisationId };
  }, [selectedOrganisationId, setSelectedOrganisationId]);

  return (
    <OrganisationFilterContext.Provider value={value}>
      {children}
    </OrganisationFilterContext.Provider>
  );
};
